<div class="form-group mb-20">
    <label class="control-label col-xs-9">
        {{ "control_animation_on_scroll" | translate }}
        <span
            *ngIf="isDisabled"
            class="small sp-icon icon-question color-light hover-effect"
            [tooltip]="'animation_disabled_tooltip' | translate"
            [placement]="'top'"
            [adaptivePosition]="true"
            triggers="mouseover:mouseleave"
        ></span>
    </label>
    <div class="col-xs-3 control-switch text-right" [class.disabled]="isDisabled">
        <sp-switch [control]="isActive"></sp-switch>
    </div>
</div>

<ng-container *ngIf="isActive.value">
    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "control_animation_type" | translate }}
        </label>
        <div class="col-xs-12">
            <select class="form-control" [formControl]="animationType" (change)="setAnimation(animationType.value)">
                <option [ngValue]="EAnimationType.fade">{{ "option_animation_type_fade" | translate }}</option>
                <option [ngValue]="EAnimationType.scale">{{ "option_animation_type_scale" | translate }}</option>
                <option [ngValue]="EAnimationType.slide">{{ "option_animation_type_slide" | translate }}</option>
                <option *ngIf="isText" [ngValue]="EAnimationType.runningStripe">
                    {{ "option_animation_type_running_stripe" | translate }}
                </option>
            </select>

            <div
                *ngIf="animationType.value === EAnimationType.runningStripe"
                class="alert alert-info-mutted alert-sm mb-0 mt-10"
            >
                {{ "alert_running_stripe_animation" | translate }}
            </div>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "control_animation_position" | translate }}
        </label>
        <div class="col-xs-12">
            <select class="form-control" [formControl]="animationPosition">
                <option [ngValue]="EAnimationPosition.left">{{ "option_animation_position_left" | translate }}</option>
                <option *ngIf="animationType.value !== EAnimationType.runningStripe" [ngValue]="EAnimationPosition.top">
                    {{ "option_animation_position_top" | translate }}
                </option>
                <option [ngValue]="EAnimationPosition.right">
                    {{ "option_animation_position_right" | translate }}
                </option>
                <option
                    *ngIf="animationType.value !== EAnimationType.runningStripe"
                    [ngValue]="EAnimationPosition.bottom"
                >
                    {{ "option_animation_position_bottom" | translate }}
                </option>
            </select>
        </div>
    </div>

    <div class="form-group">
        <label class="col-xs-12">
            {{ "control_animation_speed" | translate }}
        </label>
        <div class="col-xs-12">
            <select class="form-control" [formControl]="animationSpeed">
                <option [ngValue]="EAnimationSpeed.slow">{{ "option_animation_speed_slow" | translate }}</option>
                <option [ngValue]="EAnimationSpeed.medium">{{ "option_animation_speed_medium" | translate }}</option>
                <option [ngValue]="EAnimationSpeed.fast">{{ "option_animation_speed_fast" | translate }}</option>
            </select>
        </div>
    </div>
</ng-container>
